import { render } from "./UpcomingMatches.vue?vue&type=template&id=631eb144&scoped=true"
import script from "./UpcomingMatches.vue?vue&type=script&lang=js"
export * from "./UpcomingMatches.vue?vue&type=script&lang=js"

import "./UpcomingMatches.vue?vue&type=style&index=0&id=631eb144&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631eb144"]])

export default __exports__